import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import navigationQuery from '~/graphql/navigation.gql';
import SitemapList from '~/components/specific/Sitemap/SitemapList.vue';
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import MdmBreadcrumb from '~/components/atoms/Global/MdmBreadcrumb.vue';
export default {
  components: {
    SitemapList,
    TitleSection,
    MdmBreadcrumb
  },
  httpHeaders: () => ({
    'Cache-Control': 'max-age=0, s-maxage=86400, public'
  }),

  data() {
    return {
      navigation: []
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    homeUrl: 'i18n/homeUrl'
  }), {
    filteredNavigation() {
      const tmpList = this.navigation ? this.navigation.filter(e => e.flatable) : null;
      return tmpList && tmpList[0] && tmpList[0].items ? tmpList[0].items : [];
    },

    sitemapTitle() {
      return {
        type: 'heading1',
        text: this.$t('sitemap')
      };
    },

    sitemapBreadcrumb() {
      return [{
        text: this.$t('home'),
        href: this.homeUrl,
        to: ''
      }, {
        text: this.$t('sitemap'),
        href: '',
        to: ''
      }];
    }

  }),

  head() {
    return {
      title: this.$i18n.t('metaTitle'),
      meta: [{
        name: 'description',
        content: this.$i18n.t('metaDescription')
      }]
    };
  },

  apollo: {
    navigation: {
      query: navigationQuery,

      variables() {
        return {
          locale: this.locale.iso
        };
      }

    }
  }
};